
export default {
  name: 'PageGiftVouchers',

  head() {
    return {
      title: 'Gift Vouchers',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Are you looking for that perfect gift to give to a dog owner? Purchase one of our gift cards for others to enjoy a stress-free walk with their pooch!'
        }
      ]
    }
  },

  computed: {
    compHero() {
      return {
        title: 'Gift Vouchers',
        image: require('~/assets/images/backgrounds/voucher-hero.jpg'),
        alt: '3 dogs in a paddock'
      }
    }
  }
}
